import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core'

@Component({
  selector: 'dmmp-website-featured-link',
  templateUrl: './website-featured-link.component.html'
})
export class WebsiteFeaturedLinkComponent implements OnInit {
  @Input() identifier
  @Input() module
  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()
  constructor() {
  }

  ngOnInit() {
  }
}
